import React, { useState } from 'react';
import TeacherNavBar from '../components/TeacherNavbar';
import { Box, Button, TextField, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';

function ContactUs() {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) {
      alert(t('يرجى كتابة رسالتك قبل الإرسال.'));
      return;
    }
  
    setLoading(true);
  
    try {
      // Get the current user
      const currentUser = auth.currentUser;
      if (!currentUser) {
        alert(t('يرجى تسجيل الدخول.'));
        setLoading(false);
        return;
      }
  
      const userId = currentUser.uid; // Get the current user's authID
      console.log(userId);
  
      // Initialize user data
      let userData = null;
  
      // Search in students collection
      const studentsQuery = query(collection(db, 'students'), where('authID', '==', userId));
      const studentSnapshot = await getDocs(studentsQuery);
  
      if (!studentSnapshot.empty) {
        const studentDoc = studentSnapshot.docs[0];
        userData = { ...studentDoc.data() };
      } else {
        // Search in teachers collection
        const teachersQuery = query(collection(db, 'teachers'), where('uid', '==', userId));
        const teacherSnapshot = await getDocs(teachersQuery);
  
        if (!teacherSnapshot.empty) {
          const teacherDoc = teacherSnapshot.docs[0];
          userData = { ...teacherDoc.data() };
        }
      }
  
      // If no user data is found, show an alert and exit
      if (!userData) {
        alert(t('لم يتم العثور على معلومات المستخدم.'));
        setLoading(false);
        return;
      }
  
      // Add complaint to contactUs collection
      await addDoc(collection(db, 'contactUs'), {
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
        message,
        isSolved: false,
        createdAt: serverTimestamp(),
        createdAtIso: new Date().toISOString(),
      });
  
      setMessage('');
      setSuccess(true); // Indicate success to the user
    } catch (error) {
      console.error('Error submitting form:', error);
      alert(t('حدث خطأ أثناء إرسال النموذج. يرجى المحاولة مرة أخرى.'));
    }
  
    setLoading(false);
  };
  

  return (
    <div
      style={{
        background:
          'radial-gradient(1200px 600px at 10% -10%, rgba(255, 204, 155, 0.35), transparent 60%), radial-gradient(900px 500px at 100% 0%, rgba(130, 189, 255, 0.35), transparent 60%), #f6f7fb',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '"Space Grotesk", "Work Sans", system-ui, sans-serif',
        overflowX: 'hidden',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >

      <TeacherNavBar />

      <Box
        sx={{
          maxWidth: '600px',
          margin: '20px auto',
          padding: '20px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#f9f9f9',
          marginTop: '100px',
          marginBottom: '20%',
          textAlign: 'right',
        }}
      >

        <Typography variant="h5" align="center" sx={{ marginBottom: '20px' }}>
          <b>{t('نموذج الاتصال بنا')}</b>
        </Typography>

        <Typography align="center" sx={{ marginBottom: '20px', fontSize: '18px' }}>
          {t('تواجهك مشكلة في التطبيق أو في الدورة بشكل عام؟ قم بملء النموذج التالي وسنقوم بحلها في أقرب وقت ممكن.')}
        </Typography>

        <TextField
          label={t('صف مشكلتك')}
          variant="outlined"
          fullWidth
          required
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{ marginBottom: '20px' }}
        />

        <Button
          variant="contained"
          sx={{ fontSize: '15px', backgroundColor: "#12344d" }}
          fullWidth
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? t('جارٍ الإرسال...') : t('إرسال النموذج')}
        </Button>

        {success && (
          <Alert severity="success" sx={{ marginBottom: '20px', marginTop: '15px',direction: 'rtl' }}>
            {t('تم إرسال النموذج بنجاح. سنقوم بالرد عليك قريبًا.')}
          </Alert>
        )}
      </Box>
      <div>
        <br />
      </div>
    </div>
  );
}

export default ContactUs;
